// extracted by mini-css-extract-plugin
export var resizer = "_gf-0";